export default __webpack_public_path__ + "static/icon-17-3-df1eee78d76c752f6e827c46ddf5bd73.png";